import { LoaderDots } from "@components/common/LoaderDots/LoaderDots";
import { DidYouKnow } from "@components/common/DidYouKnow/DidYouKnow";
import { useTranslation } from "react-i18next";
import { useDAP } from "../dap.hook";

export function SearchLoader({ type }: { type?: "outward" | "return" }) {
  const { t } = useTranslation();
  const { dap } = useDAP();
  const place = type === "outward" ? dap?.destination?.name : dap?.origin?.name;
  return (
    <div
      data-testid="search-loader"
      className=" fixed z-[1000] left-0   top-[112px]  md:top-[160px]  right-0 bottom-0 bg-[#EFF2F7] flex flex-col gap-[88px] md:gap-[104px] items-center justify-center px-8"
    >
      <p className="text-center text-strong text-sm md:text-[20px] font-jakarta ">
        {t("loader.search", { place: place })}
      </p>
      <LoaderDots />
      <DidYouKnow />
    </div>
  );
}
